export default "__VITE_ASSET__05fa1f44__"